import Dexie, { type Table } from "dexie";
import type {
  EventDto,
  JobDto,
  PhotoMetaDto,
  SyncStatus,
  VehicleDto,
  WorkingDayDto,
} from "../../shared/types";

export interface LocalPhoto extends PhotoMetaDto {
  blob?: Blob;
  syncStatus: SyncStatus;
}

export interface LocalWorkingDay extends WorkingDayDto {
  syncStatus: SyncStatus;
}

export interface LocalJob extends JobDto {
  syncStatus: SyncStatus;
}

export interface LocalEvent extends EventDto {
  syncStatus: SyncStatus;
}

export interface MetaRow {
  key: string;
  value: string;
}

class LogProofDB extends Dexie {
  workingDays!: Table<LocalWorkingDay, string>;
  jobs!: Table<LocalJob, string>;
  events!: Table<LocalEvent, string>;
  photos!: Table<LocalPhoto, string>;
  vehicles!: Table<VehicleDto, string>;
  meta!: Table<MetaRow, string>;

  constructor() {
    super("logproof");
    this.version(1).stores({
      workingDays: "id, status, syncStatus",
      jobs: "id, workingDayId, syncStatus",
      events: "id, workingDayId, jobId, syncStatus",
      photos: "id, workingDayId, syncStatus, verificationStatus",
      vehicles: "id",
      meta: "key",
    });
  }
}

export const db = new LogProofDB();

export async function getMeta(key: string): Promise<string | null> {
  const row = await db.meta.get(key);
  return row?.value ?? null;
}

export async function setMeta(key: string, value: string): Promise<void> {
  await db.meta.put({ key, value });
}

export function nowIso(): string {
  return new Date().toISOString();
}

export function newId(prefix: string): string {
  return `${prefix}_${crypto.randomUUID()}`;
}
